import { COMPANIES, CONTACTS, OPPORTUNITIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';

export const advancedConfig = {
    [COMPANIES.entity]: [
        {
            id: 'nombre',
            field: 'Name',
            description: getLiteral('label_account_name'),
            title: true,
        },
        { id: 'tel', field: 'Tel', description: getLiteral('label_phone_number') },
        { id: 'fax', field: 'Fax', description: getLiteral('label_fax') },
        { id: 'email', field: 'Email', description: getLiteral('label_email') },
        { id: 'web', field: 'Web', description: getLiteral('label_web') },
        { id: 'direccion', field: 'Address', description: getLiteral('label_address') },
        { id: 'nif', field: 'NIF', description: getLiteral('label_nif') },
    ],
    [OPPORTUNITIES.entity]: [
        {
            id: 'Reference',
            field: 'Reference',
            description: getLiteral('label_opportunity_project_name'),
            title: true,
        },
        {
            id: 'company',
            field: 'Company',
            description: getLiteral('label_account_client'),
        },
        {
            id: 'CompanyIntermediate',
            field: 'CompanyIntermediate',
            description: getLiteral('label_account_middleman'),
        },
        {
            id: 'CompanyOther',
            field: 'CompanyOther',
            description: getLiteral('label_intermediary2'),
        },
        {
            id: 'AddressCompany',
            field: 'AddressCompany',
            description: getLiteral('label_address'),
        },
    ],
    [CONTACTS.entity]: [
        {
            id: 'Name',
            field: 'Name',
            description: getLiteral('label_firstname'),
            title: true,
        },
        {
            id: 'Surnames',
            field: 'Surnames',
            description: getLiteral('label_surname'),
        },
        {
            id: 'Email',
            field: 'Email',
            description: getLiteral('label_email'),
        },
        {
            id: 'Phone',
            field: 'Phone',
            description: getLiteral('label_phone'),
        },
        {
            id: 'CellPhone',
            field: 'CellPhone',
            description: getLiteral('label_cellular'),
        },
        {
            id: 'PersonalAddress',
            field: 'PersonalAddress',
            description: getLiteral('label_address'),
        },
        {
            id: 'IdSkype',
            field: 'IdSkype',
            description: getLiteral('label_Skype'),
        },
        {
            id: 'LinkedIn',
            field: 'LinkedIn',
            description: getLiteral('label_Linkedin'),
        },
    ],
};
